import styled from 'styled-components'

import { COLORS, THEME, typeScale } from '../../styles'
import Icon from '../../components/Icon'
import NavLink from '../../components/NavLink'

const Styled = styled.div`
  min-height: inherit;
  background-color: ${THEME.COLORS.background.primary};
`
Styled.content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column nowrap;
  width: 100%;
  min-height: inherit;
`
Styled.icon = styled(Icon)`
  width: 24rem;
  height: 24rem;
`
Styled.title = styled.p`
  ${typeScale('headline3')};
  text-align: center;
  margin: 0 auto;
  max-width: 36rem;
  padding: 2.4rem 0 1.6rem;
`
Styled.button = styled.div`
  background-color: ${COLORS.powder};
  border-radius: 9999px;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.8rem 1.6rem;
`
Styled.buttonIcon = styled(Icon)`
  width: 1.6rem;
  height: 1.6rem;
`
Styled.buttonLabel = styled.span`
  ${typeScale('body')};
  color: ${THEME.COLORS.foreground.primary};
  padding-left: 0.4rem;
`
Styled.settingsLink = styled(NavLink)`
  ${typeScale('body')};
  color: ${THEME.COLORS.foreground.secondary};
  border-radius: 9999px;
  display: inline-flex;
  flex-flow: row nowrap;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  margin-top: 4.8rem;
  cursor: pointer;
  padding: 0.8rem 1.6rem;
`
Styled.settingsLinkLabel = styled.span`
  padding-right: 0.4rem;
`
Styled.settingsLinkIcon = styled(Icon)``

export default Styled
